<section class="univers-page">

  <div class="univers-header">
    <div class="header-content">
      <h1 aria-label="Bienvenue à la Caverne du Gobelin">
        <span class="mot-wrapper" *ngFor="let mot of mots">
          <span class="lettre-anim" *ngFor="let lettre of mot">
            {{ lettre }}
          </span>
        </span>
      </h1>
      <p class="intro-text">
        Depuis nos débuts, nous avons une mission simple : <br>
        <strong>Transformer chaque visiteur en joueur, et chaque joueur en passionné.</strong>
      </p>
    </div>

    <div class="wave-bottom">
      <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
        <path fill="#ffffff" fill-opacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1248,320,1152,320,1056,320C960,320,864,320,768,320C672,320,576,320,480,320C384,320,288,320,192,320C96,320,48,320,0,320Z"></path>
      </svg>
    </div>
  </div>

    <div class="back-navigation-bar">
      <div class="container">
        <gob-back (back)="goBack()"></gob-back>
      </div>
    </div>

  <div class="container">

    <div class="story-block" 
         *ngFor="let section of sections" 
         [class.reverse]="section.reverse" 
         #animBlock>
        
        <div class="text-side">
          <h3 class="subtitle-orange">{{ section.sousTitre }}</h3>
          <h2 class="title-green">{{ section.titre }}</h2>
          <div class="separator"></div>
          <p class="desc">{{ section.desc }}</p>
          
          <div class="btn-group" *ngIf="section.boutons.length > 0">
            <ng-container *ngFor="let btn of section.boutons">
              
              <a *ngIf="isExternalLink(btn.lien)"
                [href]="btn.lien"
                target="_blank"
                rel="noopener noreferrer"
                class="btn-univers">
                {{ btn.label }}
              </a>

              <a *ngIf="!isExternalLink(btn.lien)"
                [routerLink]="btn.lien"
                [fragment]="btn.fragment"
                class="btn-univers">
                {{ btn.label }}
              </a>

            </ng-container>
          </div>
        </div>

        <div class="image-side">
          <div class="img-frame">
            
            <img 
              [src]="section.images[section.currentIndex]" 
              [alt]="section.titre" 
              onerror="this.style.display='none'; this.parentNode.style.backgroundColor='#eee'">

            <ng-container *ngIf="section.images.length > 1">
              <button class="nav-btn prev" (click)="prevImage(section)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
              </button>
              <button class="nav-btn next" (click)="nextImage(section)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
              </button>
              
              <div class="dots-indicator">
                <span class="dot" 
                      *ngFor="let img of section.images; let i = index" 
                      [class.active]="i === section.currentIndex">
                </span>
              </div>
            </ng-container>

          </div>
        </div>
      </div>

    <div class="final-cta">
      <h2>Prêt à jouer ?</h2>
      <p>Nos équipes vous attendent en boutique pour vous conseiller.</p>
      <a routerLink="/products/banner/671e723620170/nouveautes" class="btn-cta-big">Voir les nouveautés</a>
    </div>

  </div>
</section>